import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Col, Grid, Row } from 'react-bootstrap';

import ContactForm from '../contact_form';

import Members from './members';

export default class ContactPage extends React.Component {
  render() {
    return (
      <Grid fluid>
        <Helmet>
          <title>Kontaktujte nás - Stužák</title>
        </Helmet>
        <h2>Kontaktujte nás</h2>
        <Grid>
          <Row>
            <Col md={8} mdOffset={2}>
              <Members style={styles.members} />
            </Col>
          </Row>
        </Grid>
        <Row className="grey" style={styles.contacts}>
          <Grid>
            <h2>Kontaktní formulář</h2>
            <Col md={8} mdOffset={2}>
              <ContactForm />
            </Col>
          </Grid>
        </Row>
      </Grid>
    );
  }
}

const styles = {
  members: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  contacts: {
    margin: '0 -30px',
    padding: '30px 0'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/contactpage/index.jsx